import React from 'react';
import moment from 'moment';
import {Button} from 'web-components';
import {getCanvasTimelineDateFromMoment} from '../canvas-timeline/canvas_timeline_util';

export const preventScrollingPastLoadMoreOverlay = (pageComponent, scrollAmount) => {
	if (!pageComponent.state.allDataLoaded) {
		// Only do scroll prevention if scrolling backwards
		if (scrollAmount < 0) {
			const upElement = document.getElementById('load-more-overlay');
			if (upElement.clientWidth > 500) {
				return false;
			}
		}
	}
	return true;
};

export const drawLoadMoreOverlay = (pageComponent, canvasContext, stepDataArray) => {
	const upElement = document.getElementById('load-more-overlay');
	if (!pageComponent.state.allDataLoaded) {
		const threeMonthsAgo = moment().subtract(3, 'months');
		const dataStartDate = getCanvasTimelineDateFromMoment(threeMonthsAgo);

		let minX = 0,
			maxX = 0;
		stepDataArray.forEach(step => {
			if (step.endDate <= dataStartDate || step.startDate < dataStartDate) {
				if (step.position < minX) {
					minX = step.position;
				}
				if (step.position + step.width > maxX) {
					maxX = step.position + step.width;
				}
			}
		});

		if (minX !== 0 && maxX !== 0) {
			const foregroundCanvas = document.getElementById('foreground-canvas');
			const canvasBounds = foregroundCanvas.getBoundingClientRect();

			const left = Math.max(minX, 0);
			const width = Math.min(canvasBounds.width, maxX - left) - 1;
			upElement.style.left = `${left + canvasBounds.x}px`;
			upElement.style.top = `${canvasBounds.y}px`;
			upElement.style.height = `${canvasBounds.height}px`;
			upElement.style.width = `${width}px`;
			upElement.style.display = 'grid';

			if (width >= 200) {
				upElement.classList.add('show-button');
			} else {
				upElement.classList.remove('show-button');
			}
		} else {
			upElement.style.left = '0';
			upElement.style.top = '0';
			upElement.style.height = '0';
			upElement.style.width = '0';
			upElement.style.display = 'none';
		}
	} else {
		upElement.style.left = '0';
		upElement.style.top = '0';
		upElement.style.height = '0';
		upElement.style.width = '0';
		upElement.style.display = 'none';
	}
};

export const LoadMoreOverlay = ({allDataLoaded, allDataLoading, onLoadMore}) => {
	return (
		<div className="load-more-overlay" id="load-more-overlay">
			{!allDataLoaded ? (
				<>
					{!allDataLoading ? (
						<div className="load-more-button">
							<Button size={Button.SIZE.STANDARD} variant={Button.VARIANT.VERY_LIGHT_GRAY_OUTLINE} onClick={onLoadMore}>
								Load More
							</Button>
						</div>
					) : (
						<div className="loading-indicator" />
					)}
					<div />
				</>
			) : null}
		</div>
	);
};
